import script from "./fullscreen-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./fullscreen-layout.vue?vue&type=script&setup=true&lang=js"

import "./fullscreen-layout.vue?vue&type=style&index=0&id=0ff4dfba&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff4dfba"]])

export default __exports__